import { Flex, Form, Typography } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { BudgetCountUp } from "../../../../../components/BudgetCountUp.tsx"
import { type ProjectFormData } from "../project-form-data.ts"

const { Text } = Typography

interface SummarySectionProps {
  form: FormInstance<ProjectFormData>
}

export function SummarySection({ form }: SummarySectionProps) {
  const data = Form.useWatch(
    (data) => ({
      sales_price: data.sales_price || 0,
      payable: data.planned_payable || 0
    }),
    form
  )

  const margin = (data?.sales_price ?? 0) - (data?.payable ?? 0)

  return (
    <div>
      <div className="space-y-3">
        <Flex justify={"space-between"} align={"center"}>
          <Text type={"secondary"}>Sales Price</Text>
          <Text strong>
            <BudgetCountUp value={data?.sales_price} />
          </Text>
        </Flex>
        <Flex justify={"space-between"} align={"center"}>
          <Text type={"secondary"}>Payable</Text>
          <Text strong>
            <BudgetCountUp value={data?.payable} />
          </Text>
        </Flex>
        <Flex justify={"space-between"} align={"center"}>
          <Text type={"secondary"}>Margin</Text>
          <Text type={"success"}>
            <BudgetCountUp value={margin} />
          </Text>
        </Flex>
        {/*<Flex justify={"space-between"} align={"center"}>*/}
        {/*  <Text type={"secondary"}>Duration</Text>*/}
        {/*  <Text strong>Est. 90 days</Text>*/}
        {/*</Flex>*/}
      </div>

      {/*<Divider />*/}

      {/*/!* Quick Actions *!/*/}
      {/*<div className="space-y-3">*/}
      {/*  <Title level={5}>Quick Actions</Title>*/}

      {/*  <Flex vertical gap={"small"}>*/}
      {/*    <Button*/}
      {/*      color={"default"}*/}
      {/*      variant={"filled"}*/}
      {/*      className={"w-full justify-start"}*/}
      {/*      icon={<PlusOutlined />}*/}
      {/*    >*/}
      {/*      Add Milestone*/}
      {/*    </Button>*/}
      {/*    <Button*/}
      {/*      color={"default"}*/}
      {/*      variant={"filled"}*/}
      {/*      className={"w-full justify-start"}*/}
      {/*      icon={<Icon type={"Dollar"} />}*/}
      {/*    >*/}
      {/*      Add Budget Line*/}
      {/*    </Button>*/}
      {/*    <Button*/}
      {/*      color={"default"}*/}
      {/*      variant={"filled"}*/}
      {/*      className={"w-full justify-start"}*/}
      {/*      icon={<LinkOutlined />}*/}
      {/*    >*/}
      {/*      Upload Doc*/}
      {/*    </Button>*/}
      {/*  </Flex>*/}
      {/*</div>*/}

      {/*<Divider />*/}

      {/*/!* Upcoming *!/*/}
      {/*<div className="space-y-3">*/}
      {/*  <Title level={5}>Upcoming</Title>*/}

      {/*  <Flex vertical gap={"small"}>*/}
      {/*    <Flex justify={"space-between"} align={"start"}>*/}
      {/*      <Flex vertical>*/}
      {/*        <Text strong>Next Receivable</Text>*/}
      {/*        <Text type={"secondary"}>Foundation - Nov 15</Text>*/}
      {/*      </Flex>*/}

      {/*      <Text strong type={"success"}>*/}
      {/*        $55,000*/}
      {/*      </Text>*/}
      {/*    </Flex>*/}

      {/*    <Flex justify={"space-between"} align={"start"}>*/}
      {/*      <Flex vertical>*/}
      {/*        <Text strong>Next Payable</Text>*/}
      {/*        <Text type={"secondary"}>Material Supply - Nov 10</Text>*/}
      {/*      </Flex>*/}

      {/*      <Text strong className={"text-orange-500"}>*/}
      {/*        $35,000*/}
      {/*      </Text>*/}
      {/*    </Flex>*/}
      {/*  </Flex>*/}
      {/*</div>*/}
    </div>
  )
}
